import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Dropdown from "../../components/Dropdown";
import GlobalRankingService from "../../services/globalRanking.service";
import Toaster from "../../components/toaster";
import Loader from "../../assets/images/icons/loader.gif";
import CustomPagination from "../../components/Pagination";
import Pagination from "../../components/CustomPagination";
import { getPeriodOptions } from "../../periodOptions";

const Leaderbord = () => {
  const createdAt = useSelector((state) => state.user.user?.createdAt);
  const [activeTab, setActiveTab] = useState("short");
  const [selectedOption, setSelectedOption] = useState("Select an Country");
  const [selectedOption2, setSelectedOption2] = useState("Select an Age");
  const [selectedOption3, setSelectedOption3] = useState("Select Game");
  const [selectedOption1, setSelectedOption1] = useState("Select Period");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const PAGE_SIZES = [10, 20, 30, 50, 100];
  const [pageSize, setPageSize] = useState(PAGE_SIZES[1]);
  /* const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const ITEMS_PER_PAGE = 20; */
  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };
  const handleOptionSelect1 = (option1) => {
    setSelectedOption1(option1.label);
  };
  const handleOptionSelect2 = (option) => {
    setSelectedOption2(option.label);
  };
  const handleOptionSelect3 = (option3) => {
    setSelectedOption3(option3.label);
  };

  const getLeaderboard = async () => {
    setIsLoading(true);
    try {
      const response = await GlobalRankingService.getLeaderboard(
        selectedOption !== "Select an Country" ? selectedOption?.value : "",
        selectedOption2 !== "Select an Age" ? selectedOption2 : "",
        selectedOption3 !== "Select Game" ? selectedOption3 : "",
        selectedOption1 !== "Select Period" ? selectedOption1 : "",
        page,
        pageSize
      );
      setData(response.data.data.slice(0, 20));
      setTotalCount(response?.data?.totalRecord);
      // setTotalPages(Math.ceil(response?.data?.totalRecord / ITEMS_PER_PAGE));
      // setActiveTab("extended");
    } catch (error) {
      Toaster("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  /* useEffect(() => {
    setSelectedOption(options[0]?.label);
    setSelectedOption2(options2[0].label);
    setSelectedOption3(options3[0].label);
  }, []); */

  /* const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  }; */

  const handleChange = (type, page) => {
    const total = totalCount / pageSize;
    const newPage = Math.ceil(total);
    if (type === "Next") {
      if (page !== newPage) {
        setPage(page + 1);
      }
    } else if (type === "Previous") {
      if (page !== 1) {
        setPage(page - 1);
      }
    } else if (type === "First") {
      if (page !== 1) {
        setPage(1);
      }
    } else if (type === "Last") {
      if (page !== newPage) {
        setPage(newPage);
      }
    } else {
      setPage(page);
    }
  };

  const handleDataPerPage = (e) => {
    setPageSize(e.target.value);
  };

  useEffect(() => {
    getLeaderboard();
  }, [selectedOption, selectedOption1, selectedOption2, selectedOption3, page]);

  /* const options = [
    { label: "ABW", value: "ABW" },
    { label: "AFG", value: "AFG" },
    { label: "AGO", value: "AGO" },
  ]; */
  const options = [
    { value: "ABW", label: "Aruba" },
    { value: "AFG", label: "Afghanistan" },
    { value: "AGO", label: "Angola" },
    { value: "AIA", label: "Anguilla" },
    { value: "ALA", label: "Åland Islands" },
    { value: "ALB", label: "Albania" },
    { value: "AND", label: "Andorra" },
    { value: "ARE", label: "United Arab Emirates" },
    { value: "ARG", label: "Argentina" },
    { value: "ARM", label: "Armenia" },
    { value: "ASM", label: "American Samoa" },
    { value: "ATA", label: "Antarctica" },
    { value: "ATF", label: "French Southern Territories" },
    { value: "ATG", label: "Antigua and Barbuda" },
    { value: "AUS", label: "Australia" },
    { value: "AUT", label: "Austria" },
    { value: "AZE", label: "Azerbaijan" },
    { value: "BDI", label: "Burundi" },
    { value: "BEL", label: "Belgium" },
    { value: "BEN", label: "Benin" },
    { value: "BES", label: "Bonaire, Sint Eustatius and Saba" },
    { value: "BFA", label: "Burkina Faso" },
    { value: "BGD", label: "Bangladesh" },
    { value: "BGR", label: "Bulgaria" },
    { value: "BHR", label: "Bahrain" },
    { value: "BHS", label: "Bahamas" },
    { value: "BIH", label: "Bosnia and Herzegovina" },
    { value: "BLM", label: "Saint Barthélemy" },
    { value: "BLR", label: "Belarus" },
    { value: "BLZ", label: "Belize" },
    { value: "BMU", label: "Bermuda" },
    { value: "BOL", label: "Bolivia" },
    { value: "BRA", label: "Brazil" },
    { value: "BRB", label: "Barbados" },
    { value: "BRN", label: "Brunei Darussalam" },
    { value: "BTN", label: "Bhutan" },
    { value: "BVT", label: "Bouvet Island" },
    { value: "BWA", label: "Botswana" },
    { value: "CAF", label: "Central African Republic" },
    { value: "CAN", label: "Canada" },
    { value: "CCK", label: "Cocos (Keeling) Islands" },
    { value: "CHE", label: "Switzerland" },
    { value: "CHL", label: "Chile" },
    { value: "CHN", label: "China" },
    { value: "CIV", label: "Côte d'Ivoire" },
    { value: "CMR", label: "Cameroon" },
    { value: "COD", label: "Congo (Democratic Republic of the)" },
    { value: "COG", label: "Congo" },
    { value: "COK", label: "Cook Islands" },
    { value: "COL", label: "Colombia" },
    { value: "COM", label: "Comoros" },
    { value: "CPV", label: "Cabo Verde" },
    { value: "CRI", label: "Costa Rica" },
    { value: "CUB", label: "Cuba" },
    { value: "CUW", label: "Curaçao" },
    { value: "CXR", label: "Christmas Island" },
    { value: "CYM", label: "Cayman Islands" },
    { value: "CYP", label: "Cyprus" },
    { value: "CZE", label: "Czechia" },
    { value: "DEU", label: "Germany" },
    { value: "DJI", label: "Djibouti" },
    { value: "DMA", label: "Dominica" },
    { value: "DNK", label: "Denmark" },
    { value: "DOM", label: "Dominican Republic" },
    { value: "DZA", label: "Algeria" },
    { value: "ECU", label: "Ecuador" },
    { value: "EGY", label: "Egypt" },
    { value: "ERI", label: "Eritrea" },
    { value: "ESH", label: "Western Sahara" },
    { value: "ESP", label: "Spain" },
    { value: "EST", label: "Estonia" },
    { value: "ETH", label: "Ethiopia" },
    { value: "FIN", label: "Finland" },
    { value: "FJI", label: "Fiji" },
    { value: "FLK", label: "Falkland Islands" },
    { value: "FRA", label: "France" },
    { value: "FRO", label: "Faroe Islands" },
    { value: "FSM", label: "Micronesia" },
    { value: "GAB", label: "Gabon" },
    { value: "GBR", label: "United Kingdom" },
    { value: "GEO", label: "Georgia" },
    { value: "GGY", label: "Guernsey" },
    { value: "GHA", label: "Ghana" },
    { value: "GIB", label: "Gibraltar" },
    { value: "GIN", label: "Guinea" },
    { value: "GLP", label: "Guadeloupe" },
    { value: "GMB", label: "Gambia" },
    { value: "GNB", label: "Guinea-Bissau" },
    { value: "GNQ", label: "Equatorial Guinea" },
    { value: "GRC", label: "Greece" },
    { value: "GRD", label: "Grenada" },
    { value: "GRL", label: "Greenland" },
    { value: "GTM", label: "Guatemala" },
    { value: "GUF", label: "French Guiana" },
    { value: "GUM", label: "Guam" },
    { value: "GUY", label: "Guyana" },
    { value: "HKG", label: "Hong Kong" },
    { value: "HMD", label: "Heard Island and McDonald Islands" },
    { value: "HND", label: "Honduras" },
    { value: "HRV", label: "Croatia" },
    { value: "HTI", label: "Haiti" },
    { value: "HUN", label: "Hungary" },
    { value: "IDN", label: "Indonesia" },
    { value: "IMN", label: "Isle of Man" },
    { value: "IND", label: "India" },
    { value: "IOT", label: "British Indian Ocean Territory" },
    { value: "IRL", label: "Ireland" },
    { value: "IRN", label: "Iran" },
    { value: "IRQ", label: "Iraq" },
    { value: "ISL", label: "Iceland" },
    { value: "ISR", label: "Israel" },
    { value: "ITA", label: "Italy" },
    { value: "JAM", label: "Jamaica" },
    { value: "JEY", label: "Jersey" },
    { value: "JOR", label: "Jordan" },
    { value: "JPN", label: "Japan" },
    { value: "KAZ", label: "Kazakhstan" },
    { value: "KEN", label: "Kenya" },
    { value: "KGZ", label: "Kyrgyzstan" },
    { value: "KHM", label: "Cambodia" },
    { value: "KIR", label: "Kiribati" },
    { value: "KNA", label: "Saint Kitts and Nevis" },
    { value: "KOR", label: "South Korea" },
    { value: "KWT", label: "Kuwait" },
    { value: "LAO", label: "Laos" },
    { value: "LBN", label: "Lebanon" },
    { value: "LBR", label: "Liberia" },
    { value: "LBY", label: "Libya" },
    { value: "LCA", label: "Saint Lucia" },
    { value: "LIE", label: "Liechtenstein" },
    { value: "LKA", label: "Sri Lanka" },
    { value: "LSO", label: "Lesotho" },
    { value: "LTU", label: "Lithuania" },
    { value: "LUX", label: "Luxembourg" },
    { value: "LVA", label: "Latvia" },
    { value: "MAC", label: "Macao" },
    { value: "MAF", label: "Saint Martin (French part)" },
    { value: "MAR", label: "Morocco" },
    { value: "MCO", label: "Monaco" },
    { value: "MDA", label: "Moldova" },
    { value: "MDG", label: "Madagascar" },
    { value: "MDV", label: "Maldives" },
    { value: "MEX", label: "Mexico" },
    { value: "MHL", label: "Marshall Islands" },
    { value: "MKD", label: "North Macedonia" },
    { value: "MLI", label: "Mali" },
    { value: "MLT", label: "Malta" },
    { value: "MMR", label: "Myanmar" },
    { value: "MNE", label: "Montenegro" },
    { value: "MNG", label: "Mongolia" },
    { value: "MNP", label: "Northern Mariana Islands" },
    { value: "MOZ", label: "Mozambique" },
    { value: "MRT", label: "Mauritania" },
    { value: "MSR", label: "Montserrat" },
    { value: "MTQ", label: "Martinique" },
    { value: "MUS", label: "Mauritius" },
    { value: "MWI", label: "Malawi" },
    { value: "MYS", label: "Malaysia" },
    { value: "MYT", label: "Mayotte" },
    { value: "NAM", label: "Namibia" },
    { value: "NCL", label: "New Caledonia" },
    { value: "NER", label: "Niger" },
    { value: "NFK", label: "Norfolk Island" },
    { value: "NGA", label: "Nigeria" },
    { value: "NIC", label: "Nicaragua" },
    { value: "NIU", label: "Niue" },
    { value: "NLD", label: "Netherlands" },
    { value: "NOR", label: "Norway" },
    { value: "NPL", label: "Nepal" },
    { value: "NRU", label: "Nauru" },
    { value: "NZL", label: "New Zealand" },
    { value: "OMN", label: "Oman" },
    { value: "PAK", label: "Pakistan" },
    { value: "PAN", label: "Panama" },
    { value: "PCN", label: "Pitcairn" },
    { value: "PER", label: "Peru" },
    { value: "PHL", label: "Philippines" },
    { value: "PLW", label: "Palau" },
    { value: "PNG", label: "Papua New Guinea" },
    { value: "POL", label: "Poland" },
    { value: "PRI", label: "Puerto Rico" },
    { value: "PRK", label: "North Korea" },
    { value: "PRT", label: "Portugal" },
    { value: "PRY", label: "Paraguay" },
    { value: "PSE", label: "Palestine" },
    { value: "PYF", label: "French Polynesia" },
    { value: "QAT", label: "Qatar" },
    { value: "REU", label: "Réunion" },
    { value: "ROU", label: "Romania" },
    { value: "RUS", label: "Russia" },
    { value: "RWA", label: "Rwanda" },
    { value: "SAU", label: "Saudi Arabia" },
    { value: "SDN", label: "Sudan" },
    { value: "SEN", label: "Senegal" },
    { value: "SGP", label: "Singapore" },
    { value: "SGS", label: "South Georgia and the South Sandwich Islands" },
    { value: "SHN", label: "Saint Helena, Ascension and Tristan da Cunha" },
    { value: "SJM", label: "Svalbard and Jan Mayen" },
    { value: "SLB", label: "Solomon Islands" },
    { value: "SLE", label: "Sierra Leone" },
    { value: "SLV", label: "El Salvador" },
    { value: "SMR", label: "San Marino" },
    { value: "SOM", label: "Somalia" },
    { value: "SPM", label: "Saint Pierre and Miquelon" },
    { value: "SRB", label: "Serbia" },
    { value: "SSD", label: "South Sudan" },
    { value: "STP", label: "Sao Tome and Principe" },
    { value: "SUR", label: "Suriname" },
    { value: "SVK", label: "Slovakia" },
    { value: "SVN", label: "Slovenia" },
    { value: "SWE", label: "Sweden" },
    { value: "SWZ", label: "Eswatini" },
    { value: "SXM", label: "Sint Maarten (Dutch part)" },
    { value: "SYC", label: "Seychelles" },
    { value: "SYR", label: "Syria" },
    { value: "TCA", label: "Turks and Caicos Islands" },
    { value: "TCD", label: "Chad" },
    { value: "TGO", label: "Togo" },
    { value: "THA", label: "Thailand" },
    { value: "TJK", label: "Tajikistan" },
    { value: "TKL", label: "Tokelau" },
    { value: "TKM", label: "Turkmenistan" },
    { value: "TLS", label: "Timor-Leste" },
    { value: "TON", label: "Tonga" },
    { value: "TTO", label: "Trinidad and Tobago" },
    { value: "TUN", label: "Tunisia" },
    { value: "TUR", label: "Turkey" },
    { value: "TUV", label: "Tuvalu" },
    { value: "TWN", label: "Taiwan" },
    { value: "TZA", label: "Tanzania" },
    { value: "UGA", label: "Uganda" },
    { value: "UKR", label: "Ukraine" },
    { value: "UMI", label: "United States Minor Outlying Islands" },
    { value: "URY", label: "Uruguay" },
    { value: "USA", label: "United States" },
    { value: "UZB", label: "Uzbekistan" },
    { value: "VAT", label: "Holy See" },
    { value: "VCT", label: "Saint Vincent and the Grenadines" },
    { value: "VEN", label: "Venezuela" },
    { value: "VGB", label: "Virgin Islands (British)" },
    { value: "VIR", label: "Virgin Islands (U.S.)" },
    { value: "VNM", label: "Vietnam" },
    { value: "VUT", label: "Vanuatu" },
    { value: "WLF", label: "Wallis and Futuna" },
    { value: "WSM", label: "Samoa" },
    { value: "YEM", label: "Yemen" },
    { value: "ZAF", label: "South Africa" },
    { value: "ZMB", label: "Zambia" },
    { value: "ZWE", label: "Zimbabwe" },
  ];

  const options1 = getPeriodOptions(createdAt);

  const options2 = [
    { label: "U7", value: "U7" },
    { label: "U9", value: "U9" },
    { label: "U11", value: "U11" },
    { label: "U15", value: "U15" },
    { label: "U16+", value: "U16+" },
  ];
  const options3 = [
    { label: "Number", value: "number" },
    { label: "Color", value: "color" },
    { label: "Shapes", value: "shapes" },
    { label: "Binary", value: "Binary" },
    { label: "Make It 9", value: "make it 9" },
    { label: "Recall", value: "recall" },
    { label: "Stroop", value: "stroop" },
    { label: "Calculator", value: "calculator" },
    { label: "Start With 1", value: "start with 1" },
    { label: "Challenge", value: "challenge" },
  ];

  return (
    <>
      <div className="max-w-7xl mx-auto">
        <div className="rounded-lg overflow-hidden ">
          <div className="w-[200px] py-4">
            <div className="flex gap-0 rounded-lg overflow-hidden">
              <button
                onClick={() => setActiveTab("short")}
                className={`relative min-w-[100px] px-4 py-2
            ${
              activeTab === "short"
                ? "bg-[#6DD47D] text-black border-b-0"
                : "bg-gray-200 text-black"
            }
            border-b border-transparent
            ${activeTab === "short" ? "-mb-[1px]" : ""}`}
              >
                Short
              </button>

              <button
                onClick={() => setActiveTab("extended")}
                className={`relative min-w-[100px] px-4 py-2
            ${
              activeTab === "extended"
                ? "bg-[#6DD47D] text-black border-b-0"
                : "bg-gray-200 text-black"
            }
            border-b border-transparent
            ${activeTab === "extended" ? "-mb-[1px]" : ""}`}
              >
                Extended
              </button>
            </div>
          </div>
          <div className="overflow-auto max-h-[400px] table-main">
            <table>
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Country</th>
                  <th>Player</th>
                  {activeTab === "extended" && (
                    <>
                      <th>Shirt No</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Drill</th>
                    </>
                  )}
                  <th>Hits</th>
                  <th>Passing</th>
                  {activeTab === "extended" && (
                    <>
                      <th>AVG Time</th>
                    </>
                  )}
                  <th>Score</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={11} className=" text-[16px] h-14">
                      <div className="flex justify-center">
                        <img src={Loader} className="h-12 w-12" alt="Loader" />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <>
                    {data?.length > 0 ? (
                      data?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.country}</td>
                          <td>{item.playername}</td>
                          {activeTab === "extended" && (
                            <>
                              <td>{item?.playerData?.tshirtNumber}</td>
                              <td>{item.date}</td>
                              <td>{item.time}</td>
                              <td>{item.drillname}</td>
                            </>
                          )}
                          <td>{item.hits}</td>
                          <td>{item.passing}</td>
                          {activeTab === "extended" && (
                            <>
                              <td>{item.time}</td>
                            </>
                          )}
                          <td>{item.score}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={11}
                          className="text-center text-[16px] h-14"
                        >
                          Data Not Found
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {data.length > 0 && (
          <CustomPagination
            total={totalCount}
            page={page}
            handleChange={handleChange}
            dataPerPage={pageSize}
            handleDataPerPage={handleDataPerPage}
            PAGE_SIZES={PAGE_SIZES}
          />
        )}
        {/* <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        /> */}
        <div className="mt-10 flex gap-4 justify-center flex-wrap">
          <Dropdown
            label={selectedOption}
            options={options}
            onSelect={handleOptionSelect}
          />
          <Dropdown
            label={selectedOption1}
            options={options1}
            onSelect={handleOptionSelect1}
          />
          <Dropdown
            label={selectedOption2}
            options={options2}
            onSelect={handleOptionSelect2}
          />
          <Dropdown
            label={selectedOption3}
            options={options3}
            onSelect={handleOptionSelect3}
          />
        </div>
      </div>
    </>
  );
};

export default Leaderbord;
